import { BindingHandler } from 'knockout';

export const stopBinding = {
  init: function () {
    return { controlsDescendantBindings: true };
  }
} as BindingHandler;